<template>
    <div class="modal fade" id="otherRestaurant" tabindex="-1" role="dialog" aria-labelledby="otherRestaurantLabel" aria-hidden="true" style=" z-index: 99999" v-if="cartRestaurant">
        <div style="display: flex; justify-content: center; align-items: center; background: rgba(0, 0, 0, .6); height: 100vh;">

      <div class="modal-dialog" role="document" style="width: 95%">
        <div class="modal-content">
          <div class="modal-body" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <h2 style="font-size: 22px" class="text-center">{{ defaultCartLanguage.restaurant_mismatch_title }}</h2>
            <p class="text-center mt-2">{{ defaultCartLanguage.restaurant_mismatch_text_pt1 }}<strong>{{ cartRestaurant.name }}</strong>. {{ defaultCartLanguage.restaurant_mismatch_text_pt2 }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-block" @click.prevent="localEmptyCart">Conferma</button>
            <button type="button" class="btn btn-secondary btn-block" style="background-color: white!important; color: #01AD83!important; border: 1px solid #EDEDED!important;" @click.prevent="hideOtherRestaurantModal">Annulla</button>
          </div>
        </div>
      </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: ['moveForward', 'attemptedContent'],

        computed: {
            ...mapGetters(['cartRestaurant', 'defaultCartLanguage'])
        },

        methods: {
            ...mapActions(['emptyCart', 'hideOtherRestaurantModal']),

            localEmptyCart() {
                this.emptyCart()
                this.moveForward(this.attemptedContent)
                this.hideOtherRestaurantModal()
            }
        }
    }
</script>
